/**
 *
 * Actions Service
 *
 */
import { FAILURE, LOADING, NAMESPACE, NOT_ASKED, ActionType } from './constants';
import reducer from './reducer';
import sagas from './sagas';
import { selectStatus, selectResult, selectError } from './selectors';
import { actionsRequest } from './actions';

// The actionsRequest() constitutes the external API for this service.
// Calling this function initiates a request.
export {
  FAILURE,
  LOADING,
  NAMESPACE,
  NOT_ASKED,
  reducer,
  sagas,
  selectStatus,
  ActionType,
  selectResult,
  selectError,
  actionsRequest,
};



// WEBPACK FOOTER //
// ./src/services/actions/index.js